<template>
  <v-card>
    <v-toolbar dark color="primary">
      <v-btn icon dark @click="handleCancelButtonClick">
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title>{{ editedClient.title }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
      <v-tabs
        v-model="active"
        fixed-tabs
        color="primary" dark
        slider-color="cyan lighten-5">
      <v-tab :key="0"> Specialists </v-tab>
      <v-tab :key="1"> Services </v-tab>
      <v-tab-item :key="0">
        <specialists :clientId="editedClient.id"
                     :items="editedClient.specialists"
                     :availableSpecialistRole="availableSpecialistRole"
        @specialistCreated="handleSpecialistCreated"
        @specialistUpdated="handleSpecialistUpdated"
        @specialistDeleted="handleSpecialistDeleted"/>
      </v-tab-item>
      <v-tab-item :key="1">
        <client-services :items="preparedClientServices"
                         @clientServiceUpdated="handleClientServiceUpdated"
                         @clientServiceDeleted="handleClientServiceDeleted"/>
      </v-tab-item>
      </v-tabs>
  </v-card>
</template>

<script>
import NoEmpty from '../Filters/NoEmpty.js'
import Specialists from './Specialists'
import ClientServices from './ClientServices'
import _ from 'lodash'

export default {
  name: 'client-details',
  filters: {
    NoEmpty
  },
  components: {
    Specialists,
    ClientServices
  },
  props: {
    editedClient: {
      type: Object
    },
    servicesById: {
      type: Object
    },
    clientServices: {
      type: Array
    },
    availableSpecialistRole: {
      type: Array
    }
  },
  data () {
    return {
      active: '0'
    }
  },
  computed: {
    preparedClientServices () {
      let result = []

      for (let item of this.clientServices) {
        let service = _.get(this.servicesById, item.serviceId, null)

        if (!service) {
          continue
        }

        result.push({
          ...item,
          title: service.title,
          code: service.code
        })
      }

      return result
    }
  },
  methods: {
    handleCancelButtonClick () {
      this.$emit('close')
    },
    handleSpecialistCreated (specialist) {
      this.$emit('clientSpecialistCreated', specialist)
    },
    handleSpecialistUpdated (specialist) {
      this.$emit('clientSpecialistUpdated', specialist)
    },
    handleSpecialistDeleted (specialist) {
      this.$emit('clientSpecialistDeleted', specialist)
    },
    handleClientServiceUpdated (clientService) {
      this.$emit('clientServiceUpdated', clientService)
    },
    handleClientServiceDeleted (clientService) {
      this.$emit('clientServiceDeleted', clientService)
    }
  }
}
</script>

<style>
  .case-param-name {
    min-width: 250px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Sales/ClientDetails.vue